/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SupplementalGetInternalFormsByQuoteIdsResponseResultsInner } from './SupplementalGetInternalFormsByQuoteIdsResponseResultsInner';
import {
    SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerFromJSON,
    SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerFromJSONTyped,
    SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerToJSON,
} from './SupplementalGetInternalFormsByQuoteIdsResponseResultsInner';

/**
 * 
 * @export
 * @interface SupplementalGetInternalFormsByQuoteIdsResponse
 */
export interface SupplementalGetInternalFormsByQuoteIdsResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplementalGetInternalFormsByQuoteIdsResponse
     */
    count?: number;
    /**
     * 
     * @type {number}
     * @memberof SupplementalGetInternalFormsByQuoteIdsResponse
     */
    limit?: number;
    /**
     * 
     * @type {Array<SupplementalGetInternalFormsByQuoteIdsResponseResultsInner>}
     * @memberof SupplementalGetInternalFormsByQuoteIdsResponse
     */
    results?: Array<SupplementalGetInternalFormsByQuoteIdsResponseResultsInner>;
}

/**
 * Check if a given object implements the SupplementalGetInternalFormsByQuoteIdsResponse interface.
 */
export function instanceOfSupplementalGetInternalFormsByQuoteIdsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SupplementalGetInternalFormsByQuoteIdsResponseFromJSON(json: any): SupplementalGetInternalFormsByQuoteIdsResponse {
    return SupplementalGetInternalFormsByQuoteIdsResponseFromJSONTyped(json, false);
}

export function SupplementalGetInternalFormsByQuoteIdsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementalGetInternalFormsByQuoteIdsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerFromJSON)),
    };
}

export function SupplementalGetInternalFormsByQuoteIdsResponseToJSON(value?: SupplementalGetInternalFormsByQuoteIdsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'limit': value.limit,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerToJSON)),
    };
}

